import { render, staticRenderFns } from "./user-subscriptions.vue?vue&type=template&id=a59af2c8&lang=html"
import script from "./user-subscriptions.vue?vue&type=script&lang=js"
export * from "./user-subscriptions.vue?vue&type=script&lang=js"
import style0 from "./user-subscriptions.vue?vue&type=style&index=0&id=a59af2c8&prod&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports